import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from '@/axios'
import config from '@/constant/config'
import { toResponse } from '@/utils/common'

const { api } = config

export const createOrder = createAsyncThunk(
  'shipping/createOrder',
  async (body, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(api.shipping.createOrder, body)
      return data
    } catch(error) {
      return rejectWithValue(toResponse(error.response))
    }
  }
)

export const shippingSlice = createSlice({
  name: 'shipping',
  initialState: {},
  reducers: {}
})

export default shippingSlice.reducer